import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';

import { AuthStack } from './AuthStack';
import { AppStack } from './AppStack';
import { AuthenticatedUserContext } from '../providers';
import { LoadingIndicator } from '../components';
import { auth } from '../config2';
import { UserContextType } from '../@types/user';

export const RootNavigator = () => {
  const { user, setUser } = React.useContext(AuthenticatedUserContext) as UserContextType;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('RootNavigator: Setting up auth listener');
    // onAuthStateChanged returns an unsubscriber
    const unsubscribeAuthStateChanged = onAuthStateChanged(
      auth,
      authenticatedUser => {
        console.log('Auth state changed:', authenticatedUser ? 'User logged in' : 'No user');
        authenticatedUser ? setUser(authenticatedUser) : setUser(null);
        setIsLoading(false);
      }
    );

    // unsubscribe auth listener on unmount
    return unsubscribeAuthStateChanged;
  }, []); // Empty dependency array - only run once on mount

  console.log('RootNavigator render:', { isLoading, user: !!user });

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <BrowserRouter>
      {user ? <AppStack /> : <AuthStack />}
    </BrowserRouter>
  );
};
